module.exports = __webpack_public_path__ + "img/AboutDataQuality.5d05fdf7.png";